import { FsEntryType } from '@lucidlink/sdk';
import { translate } from '@lucidlink/uicore';
import { streamFileChunksConcurrently, streamFileChunksSequentially, } from '../../../file-contexts-common';
import { CONCURRENT_DOWNLOAD_FILE_SIZE_THRESHOLD, DEFAULT_FILE_DOWNLOAD_CHUNK_SIZE, DOWNLOAD_ENTRY_KINDS, } from '../../constants';
import { getRecognizedFileExtensionFromFileName } from '../event-reporting';
import { bytesToMb } from '../telemetry';
const DOWNLOAD_STRATEGIES = {
    CONCURRENT: 'concurrent',
    SEQUENTIAL: 'sequential',
};
const getFileDownloadStrategy = (entrySize) => entrySize > CONCURRENT_DOWNLOAD_FILE_SIZE_THRESHOLD
    ? DOWNLOAD_STRATEGIES.CONCURRENT
    : DOWNLOAD_STRATEGIES.SEQUENTIAL;
const getFileEntryFacts = ({ entryName, entrySize, }) => ({
    downloadStrategy: getFileDownloadStrategy(entrySize),
    fileExtension: getRecognizedFileExtensionFromFileName(entryName) ?? undefined,
    fileSize: bytesToMb(entrySize),
    kind: DOWNLOAD_ENTRY_KINDS.FILE,
});
const openFileSource = ({ createChunkDownloader, entryFacts, entryId, entrySize, isExternalFile, }) => {
    const downloadChunk = createChunkDownloader({
        fsEntryKey: { id: entryId, type: FsEntryType.FILE },
        isExternalFile,
    });
    const chunks = entryFacts.downloadStrategy === DOWNLOAD_STRATEGIES.CONCURRENT
        ? streamFileChunksConcurrently({
            chunkSize: DEFAULT_FILE_DOWNLOAD_CHUNK_SIZE,
            downloadChunk,
            fileSize: entrySize,
        })
        : streamFileChunksSequentially({
            chunkSize: DEFAULT_FILE_DOWNLOAD_CHUNK_SIZE,
            downloadChunk,
        });
    const transferFacts = (sentBytes) => ({
        ...entryFacts,
        downloadedChunks: Number(sentBytes / BigInt(DEFAULT_FILE_DOWNLOAD_CHUNK_SIZE)),
        downloadedSize: bytesToMb(sentBytes),
    });
    return {
        chunks,
        cleanUp: () => Promise.resolve(),
        transferFacts,
    };
};
export const describeFileDownload = (args, { createChunkDownloader }) => {
    const { entryId, entryName, entrySize, isExternalFile } = args;
    const entryFacts = getFileEntryFacts(args);
    return {
        artifact: {
            id: entryId,
            name: entryName,
            size: entrySize,
        },
        batch: null,
        copy: {
            completed: translate('File download completed.'),
            failed: translate('The file was not fully downloaded. Please try again.'),
        },
        entryFacts,
        openSource: () => Promise.resolve(openFileSource({
            createChunkDownloader,
            entryFacts,
            entryId,
            entrySize,
            isExternalFile,
        })),
    };
};
